module.exports = __webpack_public_path__ + "img/623.Dirty_refrigerator.d97ffa45.svg";